import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import HowToPlayGameSections from './howToPlayGameSections';
import './ContentArticle.css';

const TOC_ENTRIES = [
  { id: 'word-master', label: 'Word Master' },
  { id: 'letter-hive', label: 'Letter Hive' },
  { id: 'word-rungs', label: 'Word Rungs' },
  { id: 'crossword-full', label: 'Word Square' },
  { id: 'crossword-mini', label: 'Hidden Words' },
];

export default function HowToPlayPage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace(/^#/, '');
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [location.pathname, location.hash]);

  return (
    <main className="content-article">
      <SeoHead
        title="How to play"
        description="Complete guides for Letter Quest cozy five: Word Master, Letter Hive, Word Rungs, Word Square, and Hidden Words — rules, tips, and FAQs."
        path="/how-to-play"
      />
      <h1>How to play</h1>
      <p className="content-article__meta">Rules, tips, and quick answers for every game on Letter Quest</p>

      <p className="content-article__lead">
        Letter Quest’s cozy five — Word Master, Letter Hive, Word Rungs, Word Square, and Hidden Words — are the calm
        daily ritual on the hub. Jump to a section or open a game from home and keep this guide in another tab.
      </p>

      <nav className="content-article__toc" aria-labelledby="toc-heading">
        <h2 id="toc-heading">On this page</h2>
        <ul>
          {TOC_ENTRIES.map(({ id, label }) => (
            <li key={id}>
              <Link to={`/how-to-play#${id}`}>{label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      <HowToPlayGameSections />

      <p className="content-article__footer-links">
        More: <Link to="/faq">FAQ</Link> · <Link to="/about">About</Link> · <Link to="/">← Back to games</Link>
      </p>
    </main>
  );
}
